import React from 'react';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import LinearProgress from '@mui/material/LinearProgress';
import { alpha } from '@mui/material/styles';

export const HeaderStack = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: theme.spacing(1.5),
  marginBottom: theme.spacing(1),
}));

export const CountdownProgress = styled(LinearProgress, {
  shouldForwardProp: (prop) => prop !== 'color',
})(({ theme, color }) => ({
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  height: 4,
  borderRadius: 0,
  backgroundColor: alpha(color?.light || theme.palette.success.light, 0.2),
  '& .MuiLinearProgress-bar': {
    backgroundColor: color?.main || theme.palette.success.main,
  },
}));

export const TimerText = styled(Typography)(({ theme }) => ({
  position: 'absolute',
  bottom: theme.spacing(1),
  right: theme.spacing(2),
  fontSize: '0.75rem',
  color: theme.palette.text.secondary,
  opacity: 0.7,
}));

export const TitleText = styled(Typography)(() => ({}));

export const MessageText = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(3),
}));
